export default __webpack_public_path__ + "static/media/click.7f139b39.mp3";